function readStorageValue(key) {
  try {
    return localStorage.getItem(key) || sessionStorage.getItem(key) || "";
  } catch (e) {
    return "";
  }
}

function readTokenFromStorage() {
  try {
    return (
      readStorageValue("access_token") ||
      readStorageValue("token") ||
      readStorageValue("jwt") ||
      readStorageValue("jwt_token") ||
      readStorageValue("auth_token") ||
      ""
    );
  } catch (e) {
    return "";
  }
}

function readRefreshTokenFromStorage() {
  try {
    return (
      readStorageValue("refresh_token") ||
      readStorageValue("refreshToken") ||
      readStorageValue("refresh") ||
      readStorageValue("jwt_refresh") ||
      ""
    );
  } catch (e) {
    return "";
  }
}

function parseJwtPayload(token) {
  if (!token || typeof token !== "string") return null;
  const parts = token.split(".");
  if (parts.length !== 3) return null;

  try {
    const base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64.padEnd(Math.ceil(base64.length / 4) * 4, "=");
    const json = atob(padded);
    return JSON.parse(json);
  } catch (e) {
    return null;
  }
}

export function isAccessTokenExpired(token) {
  const payload = parseJwtPayload(token);
  if (!payload || typeof payload.exp !== "number") return false;
  const now = Math.floor(Date.now() / 1000);
  return payload.exp <= now;
}

export function isRefreshTokenValid(token) {
  const payload = parseJwtPayload(token);
  if (!payload || typeof payload.exp !== "number") return false;
  const now = Math.floor(Date.now() / 1000);
  return payload.exp > now;
}

export function getValidAccessToken() {
  const token = readTokenFromStorage();
  if (!token) return "";
  if (isAccessTokenExpired(token)) return "";
  return token;
}

export function isAuthenticated() {
  const accessToken = getValidAccessToken();
  if (accessToken) return true;

  // An expired access token can still be recovered by services/api.js using
  // the refresh token, so route guards should not log the user out early.
  return isRefreshTokenValid(readRefreshTokenFromStorage());
}

export function clearAuthStorage() {
  try {
    [
      "access_token",
      "refresh_token",
      "access",
      "refresh",
      "accessToken",
      "refreshToken",
      "jwt_access",
      "jwt_refresh",
      "token",
      "jwt",
      "jwt_token",
      "auth_token",
      "user",
      "pending_payment",
      "auth_persistence",
    ].forEach((key) => {
      localStorage.removeItem(key);
      sessionStorage.removeItem(key);
    });
    sessionStorage.removeItem("pending_payment");
  } catch (e) {
    // ignore storage errors
  }
}
